import React from 'react';
import Admin from '../../pages/admin/admin.jsx';

const Dashboard = () => {
  return (
    <div className="w-full h-full">
      <Admin />
    </div>
  );
};

export default Dashboard;
